module.exports = __webpack_public_path__ + "seasonal_winter-magic_1.jpg";